export const buildSubscriber = () => {
    let storeListeners = new Map();
    const notifyStoreChange = (storeId) => {
        var _a;
        const listeners = (_a = storeListeners.get(storeId)) !== null && _a !== void 0 ? _a : [];
        listeners.forEach(callback => callback({ trigger: 'store-mutation' }));
    };
    const addStoreListener = (storeId) => (listener) => {
        var _a;
        const listeners = (_a = storeListeners.get(storeId)) !== null && _a !== void 0 ? _a : [];
        listeners.push(listener);
        storeListeners.set(storeId, listeners);
    };
    const removeStoreListener = (storeId) => (listenerToRemove) => {
        var _a;
        const listeners = (_a = storeListeners.get(storeId)) !== null && _a !== void 0 ? _a : [];
        const filteredListeners = listeners.filter(listener => listener !== listenerToRemove);
        storeListeners.set(storeId, filteredListeners);
    };
    return {
        notifyStoreChange,
        addStoreListener,
        removeStoreListener,
    };
};
